export const pageVersionsEndpoint = pageId =>
    `/api/pages/${encodeURIComponent(pageId)}/versions`;

export const toPageVersionOptions = summaryList => (summaryList || []).filter(summary => summary?.draft !== true).filter(summary => summary?.version !== null && summary?.version !== undefined).map(summary => ({
    value: String(summary.version),
    label: `Version ${summary.version}`,
}));

export const toPageVersionResults = summaryList => ({
    success: true,
    results: toPageVersionOptions(summaryList).map(option => ({
        value: option.value,
        name: option.label,
    })),
});
